import {
  AfterContentInit,
  Component,
  contentChildren,
  ElementRef,
  inject,
  input,
  model,
  signal,
  TemplateRef,
  viewChild,
  ChangeDetectionStrategy
} from '@angular/core';
import {CheckboxComponent} from "../base/checkbox/checkbox.component";
import {BarComponent} from "../base/bar/bar.component";
import {IconComponent, IconSet, IconType} from "../base/icon/icon.component";
import {DomSanitizer} from "@angular/platform-browser";
import {ControlContainer, FormControl, FormGroupDirective} from "@angular/forms";
import {TemplateForDirective} from "../../templating/template-for.directive";
import {NgTemplateOutlet} from "@angular/common";
import {FlexModule} from "@ngbracket/ngx-layout";

@Component({
  selector: 'app-lib-checkbox-bar',
  imports: [
    CheckboxComponent,
    BarComponent,
    IconComponent,
    NgTemplateOutlet,
    FlexModule
  ],
  templateUrl: './checkbox-bar.component.html',
  styleUrl: './checkbox-bar.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  viewProviders: [{provide: ControlContainer, useExisting: FormGroupDirective}]
})
export class CheckboxBarComponent implements AfterContentInit {


  templates = contentChildren(TemplateForDirective);
  notice = signal<TemplateRef<unknown>|undefined>(undefined);
  content = signal<TemplateRef<unknown>|undefined>(undefined);

  // eslint-disable-next-line @angular-eslint/no-input-rename
  titleContent = input.required<string>({alias: 'title'});
  subTitle = input<string|null>(null);
  noticeTitle = input<string|null>(null);
  noticeContent = input<string|null>(null);
  checked = model<boolean>(false);
  protected readonly IconSet = IconSet;
  protected readonly IconType = IconType;
  sanitizer = inject(DomSanitizer);

  parentForm = inject(FormGroupDirective, {optional: true});
  control = input<FormControl | string | null>(null);
  noticeType = input<'none'|'info' | 'warning' | 'error'|'success'>('none');

  private readonly checkbox = viewChild.required(CheckboxComponent);
  private readonly checkboxEl = viewChild.required(CheckboxComponent, {read: ElementRef});
  private readonly noticeEl = viewChild<ElementRef<HTMLElement>>('noticeEl');

  // The whole frame toggles, padding included, except the checkbox, which toggles itself, and this
  // bar's own notice, which can hold a form or another bar. Checking our own elements (not
  // `closest('.notice')`) keeps a bar nested in another bar's notice working.
  protected frameClicked(event: MouseEvent) {
    const target = event.target as Node;
    if (this.checkboxEl().nativeElement.contains(target) || this.noticeEl()?.nativeElement.contains(target)) {
      return;
    }
    this.checkbox().toggle();
  }

  ngAfterContentInit() {
    TemplateForDirective.Bind(this, this.templates());
    // console.log('CheckboxBarComponent.ngAfterContentInit', this.titleContent(), {templates: this.templates(),notice: this.notice()});
  }
}
